import { useSnackbarContext } from 'Context/SnackbarContext';
import React from 'react';
import fr from 'facet-rest';
import useComponentDidMount from 'Hooks/useComponentDidMount';
import {
  FDBox,
  FDCallToActionButton, FDPaper, FDStack,
} from '@facet-wealth/design';
import RichTextDisplayPicker from 'Organisms/MessageList/MessageListItem/MessageContent/Content/RichTextDisplayPicker';
import { noop } from 'Helpers/PropTypes';
import PropTypes from 'prop-types';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';

const MessageWithPageLinkContent = ({
  messageResource,
  onLoadComplete,
}) => {
  const [loading, setLoading] = React.useState(false);
  const { loadPageContentLink } = usePageContentContext();
  const { displayErrorMessage } = useSnackbarContext();
  const relationship = messageResource.relationship(fr.relationships.specificPageLink.name);

  useComponentDidMount(async () => {
    onLoadComplete();
  });

  const handleClick = async () => {
    setLoading(true);
    try {
      await loadPageContentLink(relationship.link('related'));
    } catch (err) {
      if (err.errors) {
        displayErrorMessage(err, err.errors);
      } else {
        displayErrorMessage(err, 'Error: Button click failed, please try again');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <FDStack spacing={2} direction={'column'}>
      <RichTextDisplayPicker content={messageResource.attr('content')} resource={messageResource} />
      <FDBox paddingY={2}>
        {/* FDPaper is needed so that the CallToActionButton isn't inverted on desktop */}
        <FDPaper appearance={'flat'}>
          <FDCallToActionButton
            label={relationship.meta('prompt')}
            loading={loading}
            onClick={handleClick}
          />
        </FDPaper>
      </FDBox>
    </FDStack>
  );
};

MessageWithPageLinkContent.defaultProps = {
  onLoadComplete: noop,
};

MessageWithPageLinkContent.propTypes = {
  messageResource: PropTypes.object.isRequired,
  onLoadComplete: PropTypes.func,
};

export default MessageWithPageLinkContent;
